import type { IFundamenteiBlogFieldsFragment } from "components/content/graphql/fragments/__generated__/FundamenteiBlogFields.generated";
import classNames from "components/ui/classNames";
import { FormattedMessage } from "react-intl";

interface LatestArticlesProps {
  articles: IFundamenteiBlogFieldsFragment[];
}

export default function LatestArticles({ articles }: LatestArticlesProps) {
  return (
    <div className="w-full space-y-4 lg:ml-auto lg:max-w-96">
      <h3 className="border-b pb-2 text-2xl font-medium dark:border-b-slate-700 dark:text-slate-50">
        <FormattedMessage defaultMessage="Veja também" id="inYnL9" />
      </h3>
      <div className="flex flex-col gap-y-4">
        {articles.map((article) => (
          <div
            key={article.sys.id}
            className="flex items-center gap-x-2 rounded-2xl bg-slate-100 p-2 dark:bg-slate-600/10"
          >
            {article.cover && article.cover.url && (
              <img
                alt={article.cover.description || article.cover.title || ""}
                loading="lazy"
                src={article.cover.url}
                className="aspect-w-video w-24 rounded-xl object-cover object-left"
              />
            )}
            <a
              href={`/blog/${article.slug}`}
              title={article.title || undefined}
              className={classNames(
                "line-clamp-2 rounded-xl text-base font-medium text-slate-700",
                "hover:text-blue-600 hover:underline",
                "dark:text-slate-300",
              )}
            >
              {article.title}
            </a>
          </div>
        ))}
      </div>
    </div>
  );
}
